import { gql } from '@apollo/client';

// ===== 常量 =====

export const STATUS_DISABLED = 0;
export const STATUS_ENABLED = 1;

// ===== Types =====

export interface AddressKeywordRuleType {
  id: string;
  priority: number;
  status: number;
  keywordFrom: string;
  keywordTo: string;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
  testAddress?: string | null;
  testResult?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressKeywordRulePageResponse {
  content: AddressKeywordRuleType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressKeywordRuleListResponse {
  addressKeywordRuleList: AddressKeywordRulePageResponse;
}

export interface CreateAddressKeywordRuleInput {
  priority: number;
  status: number;
  keywordFrom: string;
  keywordTo: string;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
  testAddress: string;
  testResult: string;
}

export interface TestAddressKeywordRuleInput {
  keywordFrom: string;
  keywordTo: string;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
  testStreetAddress: string;
  testUnit?: string | null;
  testCity: string;
  testState: string;
  testZipCode: string;
}

export interface TestAddressKeywordRuleResult {
  matched: boolean;
  passed: boolean;
  reason?: string | null;
  testFullAddress: string;
  correctedStreetAddress: string;
  correctedUnit?: string | null;
  standardizedAddress?: string | null;
}

export interface TestAddressKeywordRuleResponse {
  testAddressKeywordRule: TestAddressKeywordRuleResult;
}

// ===== Query =====

export const GET_ADDRESS_KEYWORD_RULE_LIST = gql`
  query GetAddressKeywordRuleList(
    $keywordFrom: String
    $keywordTo: String
    $status: Int
    $state: String
    $city: String
    $zipCode: String
    $page: Int!
    $size: Int!
  ) {
    addressKeywordRuleList(
      keywordFrom: $keywordFrom
      keywordTo: $keywordTo
      status: $status
      state: $state
      city: $city
      zipCode: $zipCode
      page: $page
      size: $size
    ) {
      content {
        id
        priority
        status
        keywordFrom
        keywordTo
        state
        city
        zipCode
        testAddress
        testResult
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const TEST_ADDRESS_KEYWORD_RULE = gql`
  query TestAddressKeywordRule($input: TestAddressKeywordRuleInput!) {
    testAddressKeywordRule(input: $input) {
      matched
      passed
      reason
      testFullAddress
      correctedStreetAddress
      correctedUnit
      standardizedAddress
    }
  }
`;

// ===== Mutations =====

export const CREATE_ADDRESS_KEYWORD_RULE = gql`
  mutation CreateAddressKeywordRule($input: CreateAddressKeywordRuleInput!) {
    createAddressKeywordRule(input: $input) {
      id
      keywordFrom
    }
  }
`;

export const UPDATE_ADDRESS_KEYWORD_RULE_STATUS = gql`
  mutation UpdateAddressKeywordRuleStatus($id: Long!, $status: Int!) {
    updateAddressKeywordRuleStatus(id: $id, status: $status)
  }
`;

export const DELETE_ADDRESS_KEYWORD_RULE = gql`
  mutation DeleteAddressKeywordRule($id: Long!) {
    deleteAddressKeywordRule(id: $id)
  }
`;
